import { Room } from '@weblite/ts-action/room'
import { createStorage } from '../lib/storage'
import {
  createKeyvalStorage,
  createKeyvalView,
} from '$logic/lib/keyval.storage'

export const [roomsStorage, roomsReducer] = createStorage<Room>('rooms')

class NonClientRoomsStorage {
  private rooms: Record<string, Room> = {}

  get(roomId: string) {
    return this.rooms[roomId]
  }

  add(room: Room) {
    this.rooms[room.id] = room
  }

  update(roomId: string, fields: Partial<Room>) {
    this.rooms[roomId] = { ...this.rooms[roomId], ...fields }
  }
}

export const nonClientRoomsStorage = new NonClientRoomsStorage()

class RoomSyncStatus {
  atLeastOnce: boolean
}

const roomSyncStatusKey = 'room-sync-status'

export const roomSyncStatusStorage =
  createKeyvalStorage<RoomSyncStatus>(roomSyncStatusKey)

export const roomSyncStatusView =
  createKeyvalView<RoomSyncStatus>(roomSyncStatusKey)
